import { DefaultState } from 'store/reducers/types';

export const READ_RECRUITER_DROPDOWN_DATA_REQUEST = "READ_RECRUITER_DROPDOWN_DATA_REQUEST";
export const READ_RECRUITER_DROPDOWN_DATA_SUCCESS = "READ_RECRUITER_DROPDOWN_DATA_SUCCESS";
export const READ_RECRUITER_DROPDOWN_DATA_FAILURE = "READ_RECRUITER_DROPDOWN_DATA_FAILURE";

export interface Recruiter {
  value: number;
  text: string;
};

export type RecruitersData = Array<Recruiter>;

export type RecruitersState = DefaultState & {
  contents?: RecruitersData;
};

interface ReadRecruitersDataRequest {
  type: typeof READ_RECRUITER_DROPDOWN_DATA_REQUEST;
};

interface ReadRecruitersDataSuccess {
  type: typeof READ_RECRUITER_DROPDOWN_DATA_SUCCESS;
  contents: RecruitersData;
}

interface ReadRecruitersDataFailure {
  type: typeof READ_RECRUITER_DROPDOWN_DATA_FAILURE;
}

export type RecruitersActionTypes = ReadRecruitersDataRequest | ReadRecruitersDataSuccess | ReadRecruitersDataFailure;